import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LeadForm from './pages/LeadForm';
import ThankYou from './components/ThankYou';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import CaseStudiesPage from './pages/CaseStudiesPage';
import CaseStudiesPageTwo from './pages/CaseStudiesPageTwo';
import CaseStudiesPageThree from './pages/CaseStudiesPageThree';
import CaseStudiesPageFour from './pages/CaseStudiesPageFour';
import ScrollToTop from './components/ScrollToTop';
import MeetTheTeam from './pages/MeetTheTeam';

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add this line */}
      <Header />
      <Routes>
        {/* Home Page */}
        <Route path="/" element={<HomePage />} />
        {/* Lead Form Page */}
        <Route path="/lead-form" element={<LeadForm />} />
        {/* Thank You Page */}
        <Route path="/thank-you" element={<ThankYou />} />
        {/* Privacy Policy */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* Privacy Policy */}
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        {/* Case Studies Page One */}
        <Route path="/case-studies-one" element={<CaseStudiesPage />} />
        {/* Case Studies Page */}
        <Route path="/case-studies-two" element={<CaseStudiesPageTwo />} />
        {/* Case Studies Page */}
        <Route path="/case-studies-three" element={<CaseStudiesPageThree />} />
        {/* Case Studies Page */}
        <Route path="/case-studies-four" element={<CaseStudiesPageFour />} />
        {/* Meet the Team Page */}
        <Route path="/meet-the-team" element={<MeetTheTeam />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;